import { render, staticRenderFns } from "./update-user-role.vue?vue&type=template&id=d4bd7336&scoped=true&"
import script from "./update-user-role.vue?vue&type=script&lang=js&"
export * from "./update-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd7336",
  null
  
)

export default component.exports